import leaflet from 'leaflet';

export class LeafletMapController {
  constructor(context) {
    this.context = context;
    this.map = null;
    this.markerLayer = null;
    this.mapInitialized = false;
    this.logIcons = new Map();
    this.defaultIcon = null;
  }

  initMap() {
    if (this.mapInitialized) return;

    delete leaflet.Icon.Default.prototype._getIconUrl;
    leaflet.Icon.Default.mergeOptions({
      iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
      iconUrl: require('leaflet/dist/images/marker-icon.png'),
      shadowUrl: require('leaflet/dist/images/marker-shadow.png')
    });

    this.defaultIcon = new leaflet.Icon({
      iconUrl: require('leaflet/dist/images/marker-icon.png'),
      iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
      shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
      iconSize: [25, 41],
      iconAnchor: [12, 41],
      popupAnchor: [1, -34]
    });

    this.map = leaflet.map(this.context.$refs.map, {
      attributionControl: false,
      worldCopyJump: false,
      maxBounds: [
        [-85, -180],
        [85, 180]
      ],
      maxBoundsViscosity: 1.0
    }).setView(this.context.center, this.context.zoom);

    leaflet.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      attribution: '© OpenStreetMap contributors',
      maxZoom: 19,
      minZoom: 3,
      tileSize: 256,
      zoomOffset: 0,
      detectRetina: true,
    }).addTo(this.map);

    leaflet.control.attribution({
      position: 'bottomright',
      prefix: false
    }).addTo(this.map);

    this.markerLayer = leaflet.layerGroup().addTo(this.map);

    this.mapInitialized = true;

    setTimeout(() => {
      this.invalidateSize();
    }, 100);
  }
  
  updateMarkers() {
    if (!this.mapInitialized) return;

    this.markerLayer.clearLayers();

    if (!this.context.markers || this.context.markers.length === 0) {
      return;
    }

    const bounds = leaflet.latLngBounds();
    let markerCount = 0;

    this.context.markers.forEach(marker => {
      if (marker.latitude && marker.longitude) {
        const position = [marker.latitude, marker.longitude];
        
        let popupContent = '';
        let markerIcon;

        if (marker.isLog) {
          popupContent = `
            <div>
              <strong>Equipamento:</strong> ${marker.equipmentName || 'N/A'}<br>
              <strong>Tipo:</strong> ${marker.logType}<br>
              <strong>Componente:</strong> ${marker.componentType || 'N/A'}<br>
              <strong>Mensagem:</strong> ${marker.message || 'N/A'}<br>
              <strong>Data do log:</strong> ${this._formatDate(marker.logDate)}<br>
              <strong>Coordenadas:</strong> ${marker.latitude}, ${marker.longitude}
            </div>
          `;
          markerIcon = this._getLogIcon(marker.equipmentStatusLogTypeID);
        } else {
          popupContent = `
            <div>
              <strong>Equipamento:</strong> ${marker.equipmentName || 'N/A'}<br>
              <strong>Estado:</strong> ${marker.equipmentStateName || 'N/A'}<br>
              <strong>Última Atualização:</strong> ${this._formatDate(marker.updatedDate)}<br>
              <strong>Coordenadas:</strong> ${marker.latitude}, ${marker.longitude}
            </div>
          `;
          markerIcon = this.defaultIcon;
        }
        
        const newMarker = leaflet.marker(position, { icon: markerIcon })
          .bindPopup(popupContent)
          .addTo(this.markerLayer);
        
        if (marker.isSelectedLog) {
          newMarker.openPopup();
        }
        
        bounds.extend(position);
        markerCount++;
      }
    });

    this._adjustMapView(markerCount, bounds);
  }

  _adjustMapView(markerCount, bounds) {
    if (markerCount > 1 && bounds.isValid()) {
      this.map.fitBounds(bounds, { padding: [50, 50], maxZoom: 14 });
    } else if (markerCount === 1) {
      const firstMarker = this.context.markers.find(m => m.latitude && m.longitude);
      if (firstMarker) {
        this.map.setView([firstMarker.latitude, firstMarker.longitude], this.context.zoom);
      }
    }
  }
  
  _getLogColor(logTypeID) {
    switch (logTypeID) {
      case 1: return '#2196F3';
      case 2: return '#FFC107';
      case 3: return '#F44336';
      default: return '#9E9E9E';
    }
  }
  
  _getLogIcon(logTypeID) {
    if (this.logIcons.has(logTypeID)) {
      return this.logIcons.get(logTypeID);
    }

    const color = this._getLogColor(logTypeID);
    const svg = `
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24">
        <circle cx="12" cy="12" r="10" fill="${color}" stroke="white" stroke-width="2"/>
      </svg>
    `;
    const iconUrl = 'data:image/svg+xml;base64,' + btoa(svg);
    
    const icon = new leaflet.Icon({
      iconUrl: iconUrl,
      iconSize: [25, 25],
      iconAnchor: [12, 12],
      popupAnchor: [0, -12]
    });

    this.logIcons.set(logTypeID, icon);
    return icon;
  }

  _formatDate(dateString) {
    if (!dateString) return 'N/A';
    const date = new Date(dateString);
    return isNaN(date.getTime()) ? 'Data inválida' : date.toLocaleString();
  }

  destroy() {
    if (this.map) {
      this.map.remove();
      this.map = null;
    }
  }

  invalidateSize() {
    if (this.map) {
      this.map.invalidateSize();
    }
  }
}